"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Nov 26 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * SessionItem converter.
 *
 * @author JMt
 */


var SessionItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SessionItemConverter, _DataObjectConverter_);

  function SessionItemConverter() {
    _classCallCheck(this, SessionItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionItemConverter).apply(this, arguments));
  }

  return SessionItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SessionItemConverter = SessionItemConverter;